<svg
  class="{{ size() }}"
  [style.width]="width()"
  [style.height]="height()"
  [attr.stroke]="stroke()"
  [style.fill]="fill()"
  [style.color]="color() || null">
  @if (href()) {
    <use [attr.href]="href()" />
  }
</svg>
